module.exports = __webpack_public_path__ + "8d0f7904db58f7b66831554221c899c2.jpg";